import { useEffect, useState } from "react";
import { useApp } from "../../hooks/AppProvider";
import { Table, InputCell, NewRowTemplate, SelectCell, getContrastColor, EditDeleteCell } from "../../components/BasicComponents";

function UsersTable({ users, onAdd, onResetPassword, onDelete }) {    
    return (
        <>
        <Table headers={["Nom", "Nom d'utilisateur", "Couleur", "", ""]}>
            {users.map(user => (
                <UserRow key={user.id} id={user.id} username={user.username} displayName={user.display_name} isPasswordSet={user.password_set} color={user.color} onResetPassword={onResetPassword} onDelete={onDelete} />
            ))}
            <NewRow onAdd={onAdd} />
        </Table> 
        </>
    );
}

function UserRow({ id, username, displayName, color, isPasswordSet, onResetPassword, onDelete }) {
    
    function resetPassword() {
        if(window.confirm("Êtes-vous sûr de vouloir réinitialiser le mot de passe de " + displayName + "?")) {            
            onResetPassword(id);
        }
    }

    function del() {
        onDelete(id);
    }
    
    return (
        <>
            <tr key={id}>
                <td>{displayName}</td>
                <td>{username}</td>
                <td style={{backgroundColor: color, color: getContrastColor(color)}}>{color}</td>
                <td>
                    {!isPasswordSet ?
                    "Mot de passe non défini" :
                    (<button onClick={resetPassword} >Réinitialiser le mot de passe</button>)}
                </td>
                <EditDeleteCell onDelete={del} change={false} />
            </tr>
        </>
    );
}

function NewRow({ onAdd }) {
    let [newName, setNewName] = useState("");

    function add() {
        onAdd(newName, data => {
            setNewName("");
        });
    }

    return (
        <NewRowTemplate>
            <InputCell value={newName} onChange={(e) => { setNewName(e.target.value) }} placeholder="Nom" /> 
            <td></td>
            <td></td>
            <td></td>
            <td>
                <button onClick={add}>Ajouter</button>
            </td>
        </NewRowTemplate>
    )
}    


function Users() {

    let app = useApp();

    let [users, setUsers] = useState([]);

    useEffect(() => {
        app.sendGet("/user/list", users => {
            if(app.emptyCheck(users)) {
                return;
            }

            setUsers(users);
        });
    }, []);


    function onAdd(name, callback = (data) => {}) {
        if(app.emptyCheck(name)) {
            return alert("Le nom ne peut pas être vide.");
        }

        if(name.length > 20) {
            return alert("La taille maximum du nom est de 20 caractères.");
        }

        name = name.trim();

        app.sendPost("/user/register", {display_name: name}, data => {
            setUsers([...users, data]);
            callback(data);
        });
    }

    function onDelete(id) {
        if(window.confirm("Êtes-vous sûr de vouloir supprimer cet enseignant?")) {
            app.sendPost("/user/delete", {id: id}, data => {
                if(data.success === false) {
                    return alert("Erreur: " + data.message);
                }

                setUsers(users.filter(user => user.id !== id));
            });
        }
    }

    function onResetPassword(id) {
        app.sendPost("/user/reset", {id: id}, data => {
            if(data.success === false) {
                return alert("Erreur: " + data.message);
            }

            setUsers(users.map(user => user.id === id ? {...user, password_set: false} : user));

        });
    }

    return (
        <>
            <h1>Les enseignants</h1>
            <UsersTable users={users} onAdd={onAdd} onResetPassword={onResetPassword} onDelete={onDelete}></UsersTable>
        </>
    );
}

export default Users;